
import React, { useContext, Children } from 'react'
import { GlobalContext } from '../GlobalContext'



type Props = {
    title?: string
    children: any
}

function FooterNavButtonFrame({
    title,
    children
}: Props) {

    const {
        isVideoMode
    } = useContext(GlobalContext)


    return <div className={`
  ${isVideoMode ? '' : ' border-t-2 border-gray-300 bg-white '} 
  fixed bottom-0 w-full flex flex-col items-center justify-center `}>


        {title && <div className={`max-w-3xl w-full px-5 pt-3 flex flex-row gap-5`}>
            <h4 className={`text-xl w-full text-center font-righteous text-brandblue`}>{title}</h4>
            </div>}

        <div className={`max-w-3xl w-full px-5 py-3 flex flex-row gap-5`}>
            {children}
        </div>


    </div>
}
export default FooterNavButtonFrame